import { Switch } from '@tempmee/react';
import { useSelector } from 'react-redux';
import { getShouldUseAttestation } from '../../../../growthbook';
import {
  useDentistDsoAttestationToggle,
  getDsoCodesFromRemoteConfig,
} from '../hooks/useDentistBenevisAttestationToggle';
import { formatDsoName } from '../../../../utils/String';
import { Spinner } from '../../../commonComponents/Spinner';

const DentistDsoAttestationToggle = ({ officeId, dsoCode }) => {
  const { isEnabled, isLoading, onToggle } =
    useDentistDsoAttestationToggle(officeId, dsoCode);
  const displayName = formatDsoName(dsoCode);

  return (
    <div
      style={{
        width: '100%',
        padding: '5px 10px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <p className="card-text" style={{ fontWeight: '600' }}>
        Allow {displayName} Attestation:
      </p>
      {isLoading ? (
        <Spinner />
      ) : (
        <Switch checked={isEnabled} onChange={onToggle} />
      )}
    </div>
  );
};

export const DentistAttestationCard = ({ officeId }) => {
  const currentUser = useSelector(
    (state) => state.users.currentUser,
  );
  const dsoCodes = getDsoCodesFromRemoteConfig();
  const userDso = currentUser?.dsoName;

  if (
    !getShouldUseAttestation()
    || !userDso
    || !dsoCodes.includes(userDso)
  ) {
    return null;
  }

  return (
    <div className="card mt-2">
      <div className="card-body">
        <div
          style={{
            width: '100%',
            alignSelf: 'center',
            paddingInline: '5%',
          }}
        >
          <div
            className="card border-0"
            style={{ marginBottom: 30 }}
          >
            <h3
              className="card-title"
              style={{ textAlign: 'center' }}
            >
              {formatDsoName(userDso)} Attestation
            </h3>
          </div>
          <DentistDsoAttestationToggle
            officeId={officeId}
            dsoCode={userDso}
          />
        </div>
      </div>
    </div>
  );
};
